import React from 'react';
import {change} from "redux-form";

import {store} from "../../main";
import {salesPersonPopupActions} from "../PageLayout/Popups/AssignSalesPersonPopup";
import {showFabricatorsPopup} from "../../actions";

export default class VisualizerSettings extends React.Component {

  updateCheckBoxField = (input, checked, tool) => {
    switch (input.name) {
      case `toolSettings[${tool}].enableQuote`:
        !input.value && store.dispatch(change('newEntity', `toolSettings[${tool}].leadCapture`, true));
        !input.value && store.dispatch(change('newEntity', `toolSettings[${tool}].twoFA`, true));
        break;
      case `toolSettings[${tool}].enableQuoteDashboard`:
        !input.value && store.dispatch(change('newEntity', `toolSettings[${tool}].leadCaptureDashboard`, true));
        !input.value && store.dispatch(change('newEntity', `toolSettings[${tool}].twoFADashboard`, true));
        break;
      case `toolSettings[${tool}].yesNoConsultationRequest`:
        if (!input.value) {
          this.showNoCallFabricatorSelection(this.props.formValues.noCallFabricatorId, tool);
        }
        break;
      case `toolSettings[${tool}].enableFingerSignature`:
        if (!input.value) {
        }
        break;
      case `toolSettings[${tool}].showPricing`:
        input.value && store.dispatch(change('newEntity', `toolSettings[${tool}].checkOut`, false));
        break;
      case `toolSettings[${tool}].enableCookiePopup`:
        input.value && store.dispatch(change('newEntity', `toolSettings[${tool}].enableCookiePopup`, false));
        break;
      case `toolSettings[${tool}].enableQuoteKitchen`:
        !input.value && store.dispatch(change('newEntity', `toolSettings[${tool}].leadCaptureKitchen`, true));
        !input.value && store.dispatch(change('newEntity', `toolSettings[${tool}].twoFAKitchen`, true));
        break;
    }
    console.log('updatingCheckBox', input.name, !input.value, tool, checked);
    store.dispatch(change('newEntity', input.name, !input.value));
  };

  handleSetNoCallFabricator = (fabricator, set = true) => {
    if (set) {
      store.dispatch(change('newEntity', 'noCallFabricatorName', fabricator.name));
      store.dispatch(change('newEntity', 'noCallFabricatorId', fabricator.id));
    } else {
      if (!store.getState().form.newEntity.values.noCallFabricatorId) {
        // if no fabricator is selected and they click cancel, uncheck the Yes/No checkbox
        store.dispatch(change('newEntity', 'yesNoConsultationRequest', false));
      }
    }
  }

  showNoCallFabricatorSelection = (noCallFabricatorId, type) => {
    this.props.showFabricatorsPopup(true, salesPersonPopupActions.chooseFabricator, {
      noCallFabricatorId,
      cb: this.handleSetNoCallFabricator,
      type
    })
  }

}
